import React, { Component } from 'react';
import FormTextGroup from 'components/forms/components/form-text-group';
import FormTextAreaGroup from 'components/forms/components/form-text-area-group';
import FormCreatableGroup from 'components/forms/components/form-createable-group';
import FormSelectGroup from 'components/forms/components/form-select-group';
import styled from 'styled-components';
import { FormSectionContainer as Container } from 'components/styled-components';
import colors from 'utils/colors';
import debounce from 'lodash/debounce';

class VendorFormSection extends Component {
	state = {
		createNewContact: false,
		// make sure our list of 'existint contacts' matches what is available in our contact list, if we come back from the second page it will use the new contacts if we don't
		vendorContact: this.props.values.vendorContact.filter(vc => this.props.contacts.findIndex(cl => cl.userID === vc.userID) >= 0),
		newVendorContacts: this.props.values.vendorContact.filter(vc => this.props.contacts.findIndex(cl => cl.userID === vc.userID) < 0)
	};
  toggle = () => {
    //this.props.setFieldValue('vendorContact', null);
    this.setState({ createNewContact: !this.state.createNewContact });
  };

	setContactField = (key,values,c) => {
		this.setState({vendorContact: values}, () => {
			this.bubbleAllContacts()
		});
	};

	// helper things...
		deepCloneNewContacts = () => {
			return this.state.newVendorContacts.map((contact) => {
				return {
					userID: null,
					firstName: contact.firstName,
					lastName: contact.lastName,
					email: contact.email
				}
			});
		}
		deepCloneOldContacts = () => {
			return this.state.vendorContact.map((contact) => {
				return {
					userID: contact.userID,
					firstName: contact.firstName,
					lastName: contact.lastName,
					email: contact.email
				}
			});
		}

		bubbleNewContacts = (newContacts) => {
			this.setState({newVendorContacts: newContacts},() => {
				this.bubbleAllContacts();
			});
		}

		bubbleAllContacts = debounce(() => {
			let contactList = this.deepCloneOldContacts()
				.concat(this.deepCloneNewContacts());
			this.props.setFieldValue('vendorContact', contactList);
		}, 500);

	addNewContact = () => {
		// getting around deep cloning since i know the shape
		let newContacts = this.deepCloneNewContacts();

		newContacts.push({
			userID: null,
			firstName: "",
			lastName: "",
			email: ""
		});

		this.bubbleNewContacts(newContacts);
	}

	removeNewContact = (contactKey) => {
		// getting around deep cloning since i know the shape
		let newContacts = this.deepCloneNewContacts()
			.filter((value, key) => key != contactKey);

		this.bubbleNewContacts(newContacts);
	};

	updateNewContact = (contactKey, fieldKey, value) => {
		let newContacts = this.deepCloneNewContacts();

		newContacts[contactKey][fieldKey] = value;

		this.bubbleNewContacts(newContacts);
	};

  render() {
    return (
      <Container>
        <FormCreatableGroup
          label="Third Party"
          placeholder="Choose a Third Party or start typing to create a new Third Party"
          value={this.props.values.vendorInformation}
          onChange={this.props.setFieldValue}
          onBlur={this.props.setFieldTouched}
          name="vendorInformation"
          asyncOptions={this.props.vendors}
          labelKey="vendorName"
          valueKey="vendorID"
          requiredLabel={true}
          {...this.props}
        />

        <FormCreatableGroup
          label="Product or Service"
          placeholder="Choose a product/service or start typing to create a new entry"
          name="productServiceName"
          value={this.props.values.productServiceName}
          onChange={this.props.setFieldValue}
          onBlur={this.props.setFieldTouched}
          labelKey="productServiceName"
          valueKey="productServiceName"
          requiredLabel={true}
          asyncOptions={this.props.products}
          {...this.props}
        />

		<React.Fragment>
			<Wrapper style={{ "marginBottom": "20px", "borderBottom": "1px solid #cccccc"}}>
				<FormSelectGroup
					label="Third Party Contact"
					value={this.state.vendorContact}
					onChange={this.setContactField}
					onBlur={this.props.setFieldTouched}
					name="vendorContact"
					asyncOptions={this.props.contacts}
					labelKey="email"
					valueKey="userID"
					class="custom-text-group"
					requiredLabel={true}
					multi={true}
					{...this.props}
				/>
				<ToggleWrapper onClick={this.addNewContact}>+ ADD NEW CONTACT</ToggleWrapper>
			</Wrapper>

			{this.state.newVendorContacts.length < 1 ? "" :
				this.state.newVendorContacts.map((contact, key) => {
					return (
						<React.Fragment key={`newContact-${key}`}>
							<Wrapper style={{ "marginBottom": "20px", "borderBottom": "1px solid #cccccc"}}>
								<FormTextGroup
									label="First Name"
									requiredLabel={true}
									class="custom-text-group"
									name="firstName"
									autoComplete="section-vendor vendor firstname"
									value={contact.firstName}
									{...this.props}
									handleChange={(event) => this.updateNewContact(key, event.target.name, event.target.value)}
								/>
								<FormTextGroup
									label="Last Name"
									requiredLabel={true}
									class="custom-text-group"
									name="lastName"
									autoComplete="section-vendor vendor lastname"
									value={contact.lastName}
									{...this.props}
									handleChange={(event) => this.updateNewContact(key, event.target.name, event.target.value)}
								/>
								<FormTextGroup
									label="Email"
									requiredLabel={true}
									name={`vendorContact[${key}].email`}
									class="custom-text-group"
									autoComplete="section-vendor vendor email"
									value={contact.email}
									{...this.props}
									handleChange={(event) => this.updateNewContact(key, 'email', event.target.value)}
								/>
								<ToggleWrapper onClick={() => this.removeNewContact(key)}>REMOVE THIS CONTACT</ToggleWrapper>
							</Wrapper>
						</React.Fragment>
					);
				})
				
			}
		</React.Fragment>

        {/* {this.props.contacts[0] && !this.state.createNewContact ? (
          <Wrapper>
            <FormSelectGroup
              label="Third Party Contact"
              value={this.props.values.vendorContact}
              onChange={this.props.setFieldValue}
              onBlur={this.props.setFieldTouched}
              name="vendorContact"
              asyncOptions={this.props.contacts}
              labelKey="email"
              valueKey="userID"
              class="custom-text-group"
              requiredLabel={true}
			  multi={true}
              {...this.props}
            />
            <ToggleWrapper onClick={this.toggle}>
              + ADD NEW CONTACT
            </ToggleWrapper>
          </Wrapper>
        ) : (
          <React.Fragment>
            <Wrapper>
              <FormTextGroup
                label="First Name"
                requiredLabel={false}
                class="custom-text-group"
                name="vendorContact[0].firstName"
                autoComplete="section-vendor vendor firstname"
                value={
                  this.props.values.vendorContact &&
                  this.props.values.vendorContact[0].firstName
                }
                {...this.props}
              />
              <FormTextGroup
                label="Last Name"
                requiredLabel={false}
                class="custom-text-group"
                name="vendorContact[0].lastName"
                autoComplete="section-vendor vendor lastname"
                value={
                  this.props.values.vendorContact &&
                  this.props.values.vendorContact[0].lastName
                }
                {...this.props}
              />
            </Wrapper>
            <Wrapper>
              <FormTextGroup
                label="Email"
                requiredLabel={true}
                name="vendorContact[0].email"
                class="custom-text-group"
                autoComplete="section-vendor vendor email"
                value={
                  this.props.values.vendorContact &&
                  this.props.values.vendorContact[0].email
                }
                {...this.props}
              />
              {this.props.contacts[0] && (
                <ToggleWrapper onClick={this.toggle}>
                  + SELECT EXISTING CONTACT
                </ToggleWrapper>
              )}
            </Wrapper>
          </React.Fragment>
        )} */}
        <Wrapper align="baseline">
          <FormTextGroup
            label="REQ / PO / Invoice"
            requiredLabel={false}
            class="small-text-group"
            name="reqPoInvoice"
            value={this.props.values.reqPoInvoice}
            {...this.props}
          />
          <FormTextAreaGroup
            label="Description"
            requiredLabel={true}
            name="description"
            class="large-text-group"
            value={this.props.values.description}
            {...this.props}
          />
        </Wrapper>
      </Container>
    );
  }
}

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-flow: row wrap;
  align-items: ${props => props.align || 'center'};
`;
const ToggleWrapper = styled.div`
  color: ${colors.primary};
  cursor: pointer;
`;

export default VendorFormSection;
